<template>
  <div class="profile" v-if="bill">
    <v-tabs
      v-model="tab"
      background-color="blue"
      center-active
      dark
      centered
      fixed-tabs
      slider-color="blue darken-3"
      slider-size="3"
    >
      <v-tab>Cuenta de cobro</v-tab>
      <v-tab>
        <v-badge
          color="green"
          :content="bill.notes.length > 0 ? bill.notes.length : '0'"
        >
          Notas
        </v-badge>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            
            <v-row class="text-left">
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Colaborador:</span>
                {{ bill.contract.employee.user.full_name }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Fecha:</span>
                {{ bill.created_at.substring(10, 0) }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Valor Pagado:</span>
                {{ bill.value | formatNumber }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"># Cuenta:</span>
                {{ bill.reference }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"># Informe:</span>
                {{ bill.report? bill.report.reference : 'N/A' }}
              </v-col>
              <v-col cols="12" md="3" v-if="bill.approval_date">
                <span class="black--text font-weight-bold"
                  >Fecha aprobación:</span
                >
                {{ bill.approval_date }}
              </v-col>
              <v-col cols="12" md="3" v-if="bill.approval_by">
                <span class="black--text font-weight-bold"
                  >Usuario que aprobó:</span
                >
                {{ bill.approval_by.full_name }}
              </v-col>
              <v-col cols="12" md="3" v-if="bill.paid_date">
                <span class="black--text font-weight-bold">Fecha pago:</span>
                {{ bill.paid_date }}
              </v-col>
              <v-col cols="12" md="3" v-if="bill.paid_by">
                <span class="black--text font-weight-bold"
                  >Usuario que pago:</span
                >
                {{ bill.paid_by.full_name }}
              </v-col>
              <v-col cols="12" md="3">
                <v-chip :color="getBillStatuColor(bill.status)" dark small>
                  {{ getBillStatus(bill.status) }}
                </v-chip>
              </v-col>
            </v-row>

            <v-row class="text-left">
              <v-col cols="12" md="3">
                <v-btn
                  color="blue"
                  rounded
                  dark
                  :href="bill.bill_url"
                  target="_blank"
                  small
                >
                  Cuenta Cobro
                  <v-icon right dark> mdi-cloud-download </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="3" v-if="bill.bill_signed_url">
                <v-btn
                  color="blue"
                  rounded
                  dark
                  :href="bill.bill_signed_url"
                  target="_blank"
                  small
                >
                  Cuenta Cobro Firmada
                  <v-icon right dark> mdi-cloud-download </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="3" v-if="bill.payroll_url">
                <v-btn
                  color="blue"
                  rounded
                  dark
                  :href="bill.payroll_url"
                  target="_blank"
                  small
                >
                  Seguridad Social
                  <v-icon right dark> mdi-cloud-download </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="3" v-if="bill.payment_support_url">
                <v-btn
                  color="blue"
                  rounded
                  dark
                  :href="bill.payment_support_url"
                  target="_blank"
                  small
                >
                  Soporte de pago
                  <v-icon right dark> mdi-cloud-download </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="3" v-if="bill.report">
                <v-btn
                  color="green"
                  rounded
                  dark
                  :href="`/reports/show/${bill.report.id}`"
                  target="_blank"
                  small
                >
                  Ver Informe
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <note-show
          :notes="bill.notes"
          :owner="bill.contract.employee.user.id"
          type="BILL"
          :bill="bill.id"
        ></note-show>
      </v-tab-item>
    </v-tabs-items>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          bottom
          right
          fixed
          color="green"
          v-bind="attrs"
          v-on="on"
          dark
          @click="upload"
        >
          <v-icon>mdi-file-upload</v-icon>
        </v-btn>
      </template>
      <span>Subir documentos</span>
    </v-tooltip>

    <!-- Dialog upload bill signed -->
    <v-dialog v-model="dialogUpload" width="550" persistent>
      <v-card>
        <v-card-title v-if="bill">
          Subir Cuenta de Cobro Firmada y Seguridad Social <br> #{{
            bill.reference
          }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formUpload" v-model="formUpload">
            <v-file-input
              accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
              label="Cuenta de Cobro Firmada"
              v-model="model.bill_signed_file"
              :rules="[
                this.$store.state.rules.required,
                this.$store.state.rules.max_file,
              ]"
              show-size
            ></v-file-input>
            <v-file-input
              accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
              label="Seguridad Social"
              v-model="model.payroll_file"
              :rules="[
                this.$store.state.rules.required,
                this.$store.state.rules.max_file,
              ]"
              show-size
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="cancelUpload">Cancelar</v-btn>
          <v-btn text color="primary" @click="saveUpload">Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BILL } from "@/store/bill";
import { SET_ALERT } from "@/store/alert";
import NoteShow from "@/components/note/Show";
export default {
  name: "BillShow",
  filters: {
    formatNumber(value) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(value);
    },
  },
  components: {
    NoteShow,
  },
  data: () => ({
    tab: null,
    bill: null,
    formUpload: true,
    dialogUpload: false,
    model: {
      support_file: null,
      payroll_file: null,
    },
    headers: [
      { text: "Nombre", value: "name", sortable: false },
      { text: "Descripción", value: "value", sortable: false },
      { text: "Acción", value: "actions", sortable: false },
    ],
  }),
  created() {
    this.$store.dispatch("getBill", this.$route.params.id);
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_BILL) {
        this.bill = state.bill.bill;
      }
    });
  },
  computed: {
    ...mapGetters(["getBillStatus", "getBillStatuColor"]),
  },
  methods: {
    upload() {
      this.dialogUpload = true;
    },
    cancelUpload() {
      this.dialogUpload = false;
      this.model = {
        support_file: null,
        payroll_file: null,
      };
    },
    saveUpload() {
      if (
        this.model.bill_signed_file == null ||
        this.model.payroll_file == null
      ) {
        this.$store.commit(SET_ALERT, {
          message: "Debe seleccionar los archivos",
          type: "error",
        });
        return;
      }

      this.model._method = "put";
      this.$store.dispatch("updateBill", {
        id: this.bill.id,
        form: this.createFormData(),
      });
      this.cancelUpload();
    },
    createFormData() {
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((element, index) => {
            formData.append(key + "[" + index + "]", element);
          });
        } else {
          if (value !== null && value !== "") {
            formData.append(key, value);
          }
        }
      });
      return formData;
    },
  },
};
</script>
<style scoped>
.profile {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
